import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogClose,
  MatDialogRef,
} from '@angular/material/dialog';
import { PresentationalAtomsModule } from '@et/presentational/atoms';
import { PdfViewerComponent } from '@et/presentational/pdf-viewer';
import { take } from 'rxjs';

export interface JournalSealPdfPreviewData {
  file: File;
  pageNumber: number;
  title?: string;
}

@Component({
  selector: 'et-journal-seal-pdf-preview',
  imports: [MatDialogClose, PresentationalAtomsModule, PdfViewerComponent],
  templateUrl: './journal-seal-pdf-preview.component.html',
  styleUrl: './journal-seal-pdf-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalSealPdfPreviewComponent {
  private readonly dialogRef =
    inject<MatDialogRef<JournalSealPdfPreviewComponent>>(MatDialogRef);
  readonly data = inject<JournalSealPdfPreviewData>(MAT_DIALOG_DATA);

  readonly ready = signal(false);

  constructor() {
    this.dialogRef
      .afterOpened()
      .pipe(take(1))
      .subscribe(() => this.ready.set(true));
  }
}
